import {combineLatest, map, switchMap} from 'rxjs';
import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {LoadComponent} from '@brunata-angular/ui';
import {BuildingServices, filterNulls} from '@brunata-angular/util';
import {MeterService} from '../meter.service';
import {MeterAndSystemInformationComponent} from './meter-and-system-information/meter-and-system-information.component';
import {EventAlarmsComponent} from '../event-alarms/event-alarms.component';
import {ReadingsComponent} from './readings/readings.component';
import {ActivatedRoute} from '@angular/router';
import {MeterMapComponent} from './meter-map/meter-map.component';
import {GalleryComponent} from '@shared/ui/gallery/gallery.component';
import {Store} from '@ngrx/store';
import {selectBuilding} from 'src/app/state/selectors';

@Component({
    selector: 'app-meter-data',
    templateUrl: './meter-data.component.html',
    styleUrl: './meter-data.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        LoadComponent,
        MeterAndSystemInformationComponent,
        EventAlarmsComponent,
        ReadingsComponent,
        MeterMapComponent,
        GalleryComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeterDataComponent {
    protected readonly buildingServices = BuildingServices;

    private readonly store = inject(Store);
    private readonly buildingDetails$ = this.store.select(selectBuilding).pipe(
        map(state => (state.status === 'success' ? state.buildingDetails : null)),
        filterNulls(),
    );
    readonly view$ = combineLatest([this.route.paramMap, this.buildingDetails$]).pipe(
        switchMap(([params, buildingDetails]) =>
            combineLatest([
                this.meterService.getMeterData(
                    buildingDetails.building.buildingNo,
                    params.get('meterid') ?? '',
                ),
                this.meterService.searchPicturesByMeterNo(params.get('meterid') ?? ''),
            ]).pipe(
                map(([meterData, meterPhotos]) => ({
                    meterData: meterData,
                    meterPhotos: meterPhotos,
                    buildingInfo: buildingDetails,
                })),
            ),
        ),
    );

    constructor(
        private meterService: MeterService,
        private route: ActivatedRoute,
    ) {}
}
